var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"job-detail-description"},[_c('div',{staticClass:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.isEn() ? _vm.job.description : _vm.job.cn_description)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }